export default Object.freeze({
  OccupationalTherapyAssistant: 2,
  OccupationalTherapist: 15,
  PhysicalTherapyAssistant: 1,
  SpeechAndLanguageTherapist: 14,
  GradeCertification: 36,
  ServiceAssistant: 17,
  Psychologist: 11,
});
